import React from 'react'

const AffiliatesComponent = () => {
  return (
    <div className="affiliateContainer"><div className="affiliateLogos">
      <a target="_blank" href="https://www.napaonline.com/en/auto-care?cid=PAIDSEARCH_Brand_Financing-Warranties_Exact_NAPAAutoCareWarranty_Google_napanationwidewarranty_Exact_Desktop">
        <img
          alt="Napa Auto Care Logo"
          height="80px"
          className="napaLogo"
          src="./images/napaautocarelogo.png"
        />
      </a><a target="_blank" href="https://www.amsoil.com/why/why-synthetic.aspx">
        <img alt="Amsoil Logo" className="amsoilLogo" height="55px" src="./images/amsoil.jpeg" />
      </a>
      <a target="_blank" href="https://www.ase.com/About-ASE.aspx">
        <img alt="ASE Logo" className="aseLogo" height="80px" src="./images/ASE.png" />
      </a>
      <a target="_blank" href="https://www.autotraining.net/about-ati/">
        <img alt="ATI Logo" className="atiLogo" height="95px" src="./images/ATI.jpg" />
      </a>
      <a target="_blank" href="https://www.bgprod.com/about/quality/">
        <img alt="BG Logo" className="bgLogo" height="60px" src="./images/BG.png" />
      </a>
      <a target="_blank" href="https://www.jasperengines.com/about">
        <img alt="Jasper Logo" className="jasperLogo" height="50px" src="./images/Jasper.jpg" />
      </a>
      

      <a
        target="_blank"
        href="https://www.snapon.com/EN/Our-Company/Our-Mission"
      >
        <img alt="Snap-On Logo" className="snaponLogo" height="40px" src="./images/snapon.png" />
      </a>
      <a target="_blank" href="https://www.boschautoparts.com/en/">
        <img alt="Bosch Logo" className="boschLogo" height="50px" src="./images/bosch.png" />
      </a>
      <a target="_blank" href="https://www.carquest.com/">
        <img alt="Car Quest Logo" className="carquestLogo" height="80px" src="./images/carquest.png" />
      </a>
      <a target="_blank" href="https://www.roughcountry.com/faq">
        <img alt="Rough Country Logo" className="rcLogo" height="60px" src="./images/RC.png" />
      </a>
      <a target="_blank" href="https://www.michelinman.com/about-us.html">
        <img alt="Michelin Logo" className="michelinLogo" height="35px" src="./images/michelin.png" />
      </a>
    </div></div>
    
  )
}

export default AffiliatesComponent
